import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';
import { TimeagoModule } from "ngx-timeago";
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgCalendarModule  } from 'ionic2-calendar';
import { SharedModule } from './shared/shared.module';
import { PaywallModule } from './paywall/paywall.module';
import { AccountInterceptor } from './services/account-interceptor';
import { TokenInterceptor } from './services/token-interceptor';
import { ResponseInterceptor } from './services/response-interceptor';
import { AuthService } from './services/auth.service';
import { OfflineMessageBarComponent } from './shared/offline-message-bar.component';
import { environment } from '../environments/environment';
import * as Sentry from "@sentry/capacitor";
import * as SentryAngular from "@sentry/angular";
import { CommonModule } from '@angular/common';
import { StripeConnectOnboardingPageModule } from './stripe-connect-onboarding/stripe-connect-onboarding.module';

if (environment.production) {
  // This is where we used to initialize Sentry
  Sentry.init(
    {
      dsn: environment.SENTRY_DSN,
  
      // Set your release version, such as "getsentry@1.0.0"
      release: "fixdd@6.2.0",
      // Set your dist version, such as "1"
      dist: "1",
      integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        SentryAngular.browserTracingIntegration(),
        // Registers the Replay integration,
        // which automatically captures Session Replays
        Sentry.replayIntegration(),
      ],
  
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
  
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    },
    // Forward the init method from @sentry/angular
    SentryAngular.init
  );
}
else {
  // Not production so lets not use Sentry??? Mock it?
}

@NgModule({
  declarations: [
    AppComponent,
    OfflineMessageBarComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  exports: [OfflineMessageBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios' // or 'md' for Material Design
    }),
    AppRoutingModule,
    PdfViewerModule,
    NgCalendarModule,
    SharedModule,
    PaywallModule,
    TimeagoModule.forRoot(),
    StripeConnectOnboardingPageModule
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AccountInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    AuthService,
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler(),
    },
    {
      provide: SentryAngular.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [SentryAngular.TraceService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {}
